const getCar = state => state.car;
const getStorageMode = state => state.storageMode;

export default {
  getCar,
  getStorageMode,
};



// WEBPACK FOOTER //
// ./src/store/modules/car/getters.js